import { render, staticRenderFns } from "./TramiteForm.vue?vue&type=template&id=a100d49c&"
import script from "./TramiteForm.vue?vue&type=script&lang=js&"
export * from "./TramiteForm.vue?vue&type=script&lang=js&"
import style0 from "./TramiteForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports